import { PayloadAuthenticated } from "@tt-app/models";

/**
 * Build headers for authenticated requests
 * @param payload credential to provide token and alias
 * @see http://joyz-internal-documentation.s3-website-ap-northeast-1.amazonaws.com/projects/private/tt4w/tt4w.html#authentication
 */
export const buildAuthHeaders = (payload: PayloadAuthenticated): { [key: string]: string } => ({
  Authorization: `Token ${payload.token}`,
  "Lingos-Users-Alias-Uuid": payload.aliasUuid
});
